import { useEffect, useRef, useState } from 'react';

/** Download URLs for Storage paths (receipts, type files), fetched once per set of paths; a path that fails is left out. */
export const useStorageUrls = (paths: string[], getUrl: (storagePath: string) => Promise<string>): Record<string, string> => {
    const [urls, setUrls] = useState<Record<string, string>>({});
    const resolve = useRef(getUrl);
    resolve.current = getUrl;
    const signature = paths.join('|');

    useEffect(() => {
        // Lookups are keyed by path, so entries of an earlier set are harmless leftovers.
        if (!signature) return undefined;
        let cancelled = false;
        Promise.all(signature.split('|').map(path => resolve.current(path).then(url => [path, url] as const).catch(err => {
            console.warn('Could not resolve file URL:', err);
            return null;
        }))).then(results => {
            if (cancelled) return;
            const next: Record<string, string> = {};
            for (const result of results) if (result) next[result[0]] = result[1];
            setUrls(next);
        });
        return () => { cancelled = true; };
    }, [signature]);

    return urls;
};
